import firebase from "firebase";
import moment from "moment";
import { setOrdersCount, setRevenue } from "../../../store/Store";

const getRevenue = () => {
  try {
    let ref = firebase
      .firestore()
      .collection("Revenue")
      .doc(moment().format("MM-YYYY"));
    let unsub = ref.onSnapshot(
      (o) => {
        if (o.exists) {
          const { net, count } = o.data();
          setRevenue(Math.round(net / 100));
          setOrdersCount(count);
        } else {
          setRevenue(0);
          setOrdersCount(0);
        }
      },
      (e) => unsub()
    );
  } catch (e) {
    console.log(e);
  }
};

export default getRevenue;
